import styled from '@emotion/styled'

export const AcceptInvitationFormWrapper = styled.div`
  width: 100%;
  max-width: 416px;
  margin: 0 auto;
`
